import { useTranslation } from "react-i18next";
import Title from "../title/Title";
import classes from "./styles.module.css";
import ProductsSlider from "../newset/productsSlider/ProductsSlider";
import { FC } from "react";
import { ProductItemType } from "src/types/products/ProductItem";


interface BestSellingProp {
    data: ProductItemType[]
}

const BestSelling: FC<BestSellingProp> = ({ data }) => {
    const { t } = useTranslation(['home']);
    return (
        <section className={classes.best}>
            <div className="container">
                <div className={classes.sectionShell}>
                    <Title title={t('best.title')} />
                    <ProductsSlider data={data} productVariant="home" cardClassName="p-1 py-2" />
                </div>
            </div>

        </section>
    )
}


export default BestSelling;
